import { deleteAccount } from '../accounts'
import { deleteAccountDocument } from '../accountDocument'
import { deleteCall } from '../calls'
import { deleteCase } from '../cases'
import { deleteCaseNote } from '../caseNote'
import { deleteCaseDocument } from '../caseDocument'
import { deleteCaseType } from '../selectLists/caseTypes'
import { deleteServiceRequest } from '../serviceRequests'
import { deleteServiceRequestNote } from '../serviceRequestNote'
import { deleteServiceRequestDocument } from '../serviceRequestDocument'
import { deleteServiceRequestType } from '../selectLists/serviceRequestTypes'
import { deleteCompany } from '../companies'
import { deleteCompanyContact } from '../companyContacts'
import { deleteCompanyContactRole } from '../selectLists/companyContactRoles'
import { deleteCompanyLastSelectedState } from '../companyLastSelectedState'
import { deleteCompanyMasterService } from '../companyMasterServices'
import { deleteCompanyMSContact } from '../companyMSContacts'
import { deleteCompanyMSService } from '../companyMSServices'
import { deleteCompanyMSTeamMember } from '../companyMSTeamMembers'
import { deleteCompanyTeamMember } from '../companyTeamMembers'
import { deleteContract } from '../contracts'
import { deleteCompanyDocument } from '../companyDocument'
import { deleteCompanyMSDocument } from '../companyMSDocument'
import { deleteCompanyMSServiceDocument } from '../companyMSServiceDocument'
import { deleteContractDocument } from '../contractDocument'
import { deleteEmail } from '../emails'
import { deleteFieldSetField } from '../fieldSetFields'
import { deleteFieldSet } from '../fieldSets'
import { deleteGroup } from '../groups'
import { deleteIndustry } from '../selectLists/industries'
import { deleteLeadSourceCampaign } from '../selectLists/leadSourceCampaigns'
import { deleteLeadSourceContact } from '../selectLists/leadSourceContacts'
import { deleteLeadSourceEvent } from '../selectLists/leadSourceEvents'
import { deleteLocation } from '../locations'
import { deleteLocationDocument } from '../locationDocument'
import { deleteLocationType } from '../selectLists/locationTypes'
import { deleteLocationHardwareCompanyOwnedItem } from '../locationHardwareCompanyOwnedItems'
import { deleteLocationHardwareTenantOwnedItem } from '../locationHardwareTenantOwnedItems'
import { deleteLocationCompanyContact } from '../locationCompanyContacts'
import { deleteOrder } from '../orders'
import { deleteOrderLastSelectedState } from '../orderLastSelectedState'
import { deleteOrderMasterService } from '../orderMasterServices'
import { deleteOrderMSService } from '../orderMSServices'
import { deleteOrderTeamMember } from '../orderTeamMembers'
import { deleteOrderDocument } from '../orderDocument'
import { deleteOrderMSDocument } from '../orderMSDocument'
import { deleteOrderMSServiceDocument } from '../orderMSServiceDocument'
import { deleteOrderMSTeamMember } from '../orderMSTeamMembers'
import { deleteOrderContact } from '../orderContacts'
import { deleteOrderMSContact } from '../orderMSContacts'
import { deleteOrderServiceOrder } from '../orderServiceOrders'
import { deleteMeeting } from '../meetings'
import { deleteOpportunity } from '../opportunities'
import { deleteOpportunityContact } from '../opportunityContacts'
import { deleteOpportunityDocument } from '../opportunityDocument'
import { deleteOpportunityMSDocument } from '../opportunityMSDocument'
import { deleteOpportunityMSServiceDocument } from '../opportunityMSServiceDocument'
import { deleteOpportunityNote } from '../opportunityNote'
import { deleteOpportunityMSNote } from '../opportunityMSNote'
import { deleteOpportunityMSServiceNote } from '../opportunityMSServiceNote'
import { deleteCompanyNote } from '../companyNote'
import { deleteCompanyMSNote } from '../companyMSNote'
import { deleteCompanyMSServiceNote } from '../companyMSServiceNote'
import { deleteOrderNote } from '../orderNote'
import { deleteOrderMSNote } from '../orderMSNote'
import { deleteOrderMSServiceNote } from '../orderMSServiceNote'
import { deleteLocationNote } from '../locationNote'
import { deleteSupplierNote } from '../supplierNote'
import { deleteSupplierProductNote } from '../supplierProductNote'
import { deleteTsdNote } from '../tsdNote'
import { deleteAccountNote } from '../accountNote'
import { deleteContractNote } from '../contractNote'
import { deleteOpportunityLastSelectedState } from '../opportunityLastSelectedState'
import { deleteOpportunityMasterService } from '../opportunityMasterServices'
import { deleteOpportunityMSContact } from '../opportunityMSContacts'
import { deleteOpportunityMSService } from '../opportunityMSServices'
import { deleteOpportunityMSTeamMember } from '../opportunityMSTeamMembers'
import { deleteOpportunityTeamMember } from '../opportunityTeamMembers'
import { deleteOpportunityStage } from '../selectLists/opportunityStages'
import { deletePerson } from '../persons'
import { deleteProject } from '../projects'
import { deleteProduct } from '../products'
import { deleteProductCategory } from '../productCategories'
import { deleteProductGroup } from '../productGroups'
import { deleteProductSubcategory } from '../productSubcategories'
import { deleteProductKitItem } from '../productKitItems'
import { deleteSubindustry } from '../selectLists/subindustries'
import { deleteSupplier } from '../suppliers'
import { deleteSupplierLastSelectedState } from '../supplierLastSelectedState'
import { deleteSupplierContact } from '../supplierContacts'
import { deleteSupplierContactRole } from '../selectLists/supplierContactRoles'
import { deleteSupplierDocument } from '../supplierDocument'
import { deleteSupplierProduct } from '../supplierProducts'
import { deleteSupplierProductDocument } from '../supplierProductDocument'
import { deleteSupplierProductItem } from '../supplierProductItems'
import { deleteSupplierResource } from '../supplierResources'
import { deleteTask } from '../task'
import { deleteTeamMember } from '../teamMembers'
import { deleteTeamMemberLastSelectedState } from '../teamMemberLastSelectedState'
import { deleteTsd } from '../tsds'
import { deleteTsdContact } from '../tsdContacts'
import { deleteTsdContactRole } from '../selectLists/tsdContactRoles'
import { deleteTsdDocument } from '../tsdDocument'
import { deleteTsdResource } from '../tsdResources'
import { deleteTsdSupplier } from '../tsdSuppliers'
import { deleteUser } from '../users'

interface DeleteEntityNamedArgs {
  entityName: string
  entityData: any
}

export async function deleteEntity({
  entityName,
  entityData,
}: DeleteEntityNamedArgs) {
  switch (entityName) {
    case 'account':
      return await deleteAccount(entityData)
    case 'accountDocument':
      return await deleteAccountDocument(entityData)

    case 'call':
      return await deleteCall(entityData)

    case 'case':
      return await deleteCase(entityData)
    case 'caseDocument':
      return await deleteCaseDocument(entityData)
    case 'caseNote':
      return await deleteCaseNote(entityData)
    case 'caseType':
      return await deleteCaseType(entityData)

    // Forked from the case* entries above (`cases-pre-sr-fork`).
    case 'serviceRequest':
      return await deleteServiceRequest(entityData)
    case 'serviceRequestDocument':
      return await deleteServiceRequestDocument(entityData)
    case 'serviceRequestNote':
      return await deleteServiceRequestNote(entityData)
    case 'serviceRequestType':
      return await deleteServiceRequestType(entityData)

    case 'company':
      return await deleteCompany(entityData)
    case 'companyContact':
      return await deleteCompanyContact(entityData)
    case 'companyContactRole':
      return await deleteCompanyContactRole(entityData)
    case 'companyDocument':
      return await deleteCompanyDocument(entityData)
    case 'companyLastSelectedState':
      return await deleteCompanyLastSelectedState(entityData)
    case 'companyMasterService':
      return await deleteCompanyMasterService(entityData)
    case 'companyMSContact':
      return await deleteCompanyMSContact(entityData)
    case 'companyMSDocument':
      return await deleteCompanyMSDocument(entityData)
    case 'companyMSService':
      return await deleteCompanyMSService(entityData)
    case 'companyMSServiceDocument':
      return await deleteCompanyMSServiceDocument(entityData)
    case 'companyMSTeamMember':
      return await deleteCompanyMSTeamMember(entityData)
    case 'companyTeamMember':
      return await deleteCompanyTeamMember(entityData)

    case 'contract':
      return await deleteContract(entityData)
    case 'contractDocument':
      return await deleteContractDocument(entityData)

    case 'email':
      return await deleteEmail(entityData)

    case 'fieldSet':
      return await deleteFieldSet(entityData)
    case 'fieldSetField':
      return await deleteFieldSetField(entityData)

    case 'group':
      return await deleteGroup(entityData)

    case 'industry':
      return await deleteIndustry(entityData)

    case 'leadSourceCampaign':
      return await deleteLeadSourceCampaign(entityData)
    case 'leadSourceContact':
      return await deleteLeadSourceContact(entityData)
    case 'leadSourceEvent':
      return await deleteLeadSourceEvent(entityData)

    case 'location':
      return await deleteLocation(entityData)
    case 'locationDocument':
      return await deleteLocationDocument(entityData)
    case 'locationHardwareCompanyOwnedItem':
      return await deleteLocationHardwareCompanyOwnedItem(entityData)
    case 'locationHardwareTenantOwnedItem':
      return await deleteLocationHardwareTenantOwnedItem(entityData)
    case 'locationCompanyContact':
      return await deleteLocationCompanyContact(entityData)
    case 'locationType':
      return await deleteLocationType(entityData)

    case 'order':
      return await deleteOrder(entityData)
    case 'orderContact':
      return await deleteOrderContact(entityData)
    case 'orderDocument':
      return await deleteOrderDocument(entityData)
    case 'orderLastSelectedState':
      return await deleteOrderLastSelectedState(entityData)
    case 'orderMasterService':
      return await deleteOrderMasterService(entityData)
    case 'orderMSContact':
      return await deleteOrderMSContact(entityData)
    case 'orderMSDocument':
      return await deleteOrderMSDocument(entityData)
    case 'orderMSService':
      return await deleteOrderMSService(entityData)
    case 'orderMSServiceDocument':
      return await deleteOrderMSServiceDocument(entityData)
    case 'orderMSTeamMember':
      return await deleteOrderMSTeamMember(entityData)
    case 'orderServiceOrder':
      return await deleteOrderServiceOrder(entityData)
    case 'orderTeamMember':
      return await deleteOrderTeamMember(entityData)

    case 'meeting':
      return await deleteMeeting(entityData)

    case 'opportunity':
      return await deleteOpportunity(entityData)
    case 'opportunityContact':
      return await deleteOpportunityContact(entityData)
    case 'opportunityDocument':
      return await deleteOpportunityDocument(entityData)
    case 'opportunityMSDocument':
      return await deleteOpportunityMSDocument(entityData)
    case 'opportunityMSServiceDocument':
      return await deleteOpportunityMSServiceDocument(entityData)
    case 'opportunityNote':
      return await deleteOpportunityNote(entityData)
    case 'opportunityMSNote':
      return await deleteOpportunityMSNote(entityData)
    case 'opportunityMSServiceNote':
      return await deleteOpportunityMSServiceNote(entityData)
    case 'companyNote':
      return await deleteCompanyNote(entityData)
    case 'companyMSNote':
      return await deleteCompanyMSNote(entityData)
    case 'companyMSServiceNote':
      return await deleteCompanyMSServiceNote(entityData)
    case 'orderNote':
      return await deleteOrderNote(entityData)
    case 'orderMSNote':
      return await deleteOrderMSNote(entityData)
    case 'orderMSServiceNote':
      return await deleteOrderMSServiceNote(entityData)
    case 'locationNote':
      return await deleteLocationNote(entityData)
    case 'supplierNote':
      return await deleteSupplierNote(entityData)
    case 'supplierProductNote':
      return await deleteSupplierProductNote(entityData)
    case 'tsdNote':
      return await deleteTsdNote(entityData)
    case 'accountNote':
      return await deleteAccountNote(entityData)
    case 'contractNote':
      return await deleteContractNote(entityData)
    case 'opportunityLastSelectedState':
      return await deleteOpportunityLastSelectedState(entityData)
    case 'opportunityMasterService':
      return await deleteOpportunityMasterService(entityData)
    case 'opportunityMSContact':
      return await deleteOpportunityMSContact(entityData)
    case 'opportunityMSService':
      return await deleteOpportunityMSService(entityData)
    case 'opportunityMSTeamMember':
      return await deleteOpportunityMSTeamMember(entityData)
    case 'opportunityTeamMember':
      return await deleteOpportunityTeamMember(entityData)
    case 'opportunityStage':
      return await deleteOpportunityStage(entityData)

    case 'person':
      return await deletePerson(entityData)

    case 'project':
      return await deleteProject(entityData)

    case 'product':
      return await deleteProduct(entityData)
    case 'productCategory':
      return await deleteProductCategory(entityData)
    case 'productGroup':
      return await deleteProductGroup(entityData)
    case 'productKitItem':
      return await deleteProductKitItem(entityData)
    case 'productSubcategory':
      return await deleteProductSubcategory(entityData)

    case 'subindustry':
      return await deleteSubindustry(entityData)

    case 'supplier':
      return await deleteSupplier(entityData)
    case 'supplierLastSelectedState':
      return await deleteSupplierLastSelectedState(entityData)
    case 'supplierContact':
      return await deleteSupplierContact(entityData)
    case 'supplierContactRole':
      return await deleteSupplierContactRole(entityData)
    case 'supplierDocument':
      return await deleteSupplierDocument(entityData)
    case 'supplierProduct':
      return await deleteSupplierProduct(entityData)
    case 'supplierProductDocument':
      return await deleteSupplierProductDocument(entityData)
    case 'supplierProductItem':
      return await deleteSupplierProductItem(entityData)
    case 'supplierResource':
      return await deleteSupplierResource(entityData)

    case 'task':
      return await deleteTask(entityData)

    case 'teamMember':
      return await deleteTeamMember(entityData)
    case 'teamMemberLastSelectedState':
      return await deleteTeamMemberLastSelectedState(entityData)

    case 'tsd':
      return await deleteTsd(entityData)
    case 'tsdContact':
      return await deleteTsdContact(entityData)
    case 'tsdContactRole':
      return await deleteTsdContactRole(entityData)
    case 'tsdDocument':
      return await deleteTsdDocument(entityData)
    case 'tsdSupplier':
      return await deleteTsdSupplier(entityData)
    case 'tsdResource':
      return await deleteTsdResource(entityData)

    case 'user':
      return await deleteUser(entityData)
    default:
      ;`[services/crud/deleteEntity] deleteEntity | Unknown entityName '${entityName}'`
  }
}
